import React from 'react'

const Support = () => {
  return (
    <main className="p-4 has-text-left" style={{maxWidth: '60%'}}>
      <h1>Baffs Support</h1>

      <p>Need help with Baffs? We're here to help.</p>

  <h2>Getting Help</h2>
  
  <p>
    If you're experiencing an issue with the Baffs app, please contact our support team at <a href="mailto:baffs.app@gmail.com">baffs.app@gmail.com</a>.</p>

  <p>When contacting us, please include:</p>

  <ul>
    <li>The email address associated with your Baffs account</li>
    <li>A brief description of the issue</li>
    <li>Your order number, if applicable</li>
    <li>A screenshot of the issue, if helpful</li>
  </ul>

  <h2 className="mt-6">Common Questions</h2>

  <h4 className="mt-4">I can't log in</h4>
  <p>Make sure you're using the email address associated with your Baffs account. If you're still having trouble, contact support and we'll help you regain access.</p>

  <h4 className="mt-4">I'm having trouble placing an order</h4>
  <p>Check that your internet connection is stable and that the app is updated to the latest version. If the problem persists, contact us with details of what happened.</p>

  <h4 className="mt-4">I have a problem with my order</h4>
  <p>For questions about an order, please contact support with yourorder number and a description of the issue.
  </p>

  <h4 className="mt-4">I'm experiencing a technical problem</h4>
  <p>Please make sure you're using the latest version of Baffs and restartthe app. If the problem continues, contact support and include yourdevice model and a screenshot if possible.
  </p>

  <div className="contact">
  <h2>Still Need Help?</h2>

  <p>
    <strong>Email:</strong>
    <a href="mailto:baffs.app@gmail.com">baffs.app@gmail.com</a>
  </p>

    <p>We'll do our best to respond as soon as possible.</p>
  </div>
  </main>
  )
}

export default Support